import { getCurrentUser } from './get_current_user.js';

export const trackCzEvent = (eventName, description, quantity, customFields) => {
  const { email } = getCurrentUser();
  if (window.ChurnZero && email.split('@').slice(-1) != 'attunedpartners.com') {
    window.ChurnZero.push(['trackEvent', eventName, description, quantity]);
  }
};
